var map = {
	"./automated-message.png": "8318",
	"./heavy-tool.png": "887f",
	"./logistic.png": "7375",
	"./officer.png": "b24d",
	"./organization.png": "f0b2",
	"./shelter.png": "e766"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d2b8";